// extracted by mini-css-extract-plugin
export default {"back":"PaymentError_back__x-zH0","heading":"PaymentError_heading__Y6-CJ","text":"PaymentError_text__b8yng","forwardButton":"PaymentError_forwardButton__89Qqh"};